import { useParamsContext } from '../../../contexts/ParamsContext';
import { useGruposClientesContext } from '../Context';
import { ChevronRight, TriangleAlert, UsersRound } from 'lucide-react';

export default function GruposClientesList() {
    const { data, loading, error, reloadData } = useGruposClientesContext();
    const { setParams } = useParamsContext();

    if (loading) {
        return (
            <div className="space-y-2 px-2" aria-busy="true">
                {[0, 1, 2].map((item) => (
                    <div key={item} className="sf-skeleton h-14" />
                ))}
            </div>
        );
    }

    if (error && !data.length) {
        return (
            <div className="sf-state">
                <TriangleAlert aria-hidden />
                <h2>Não foi possível carregar os grupos</h2>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => void reloadData()}>
                    Tentar novamente
                </button>
            </div>
        );
    }

    if (!data.length) {
        return (
            <div className="sf-state">
                <UsersRound aria-hidden />
                <h2>Nenhum grupo criado</h2>
                <p>Agrupe clientes para organizar o atendimento e enviar lembretes a quem interessa.</p>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => setParams({ action: 'add' })}>
                    Criar grupo
                </button>
            </div>
        );
    }

    return (
        <div className="sf-page px-2">
            <ul className="sf-group">
                {data.map((grupo) => (
                    <li key={grupo._id}>
                        <button
                            type="button"
                            className="sf-row"
                            onClick={() => setParams({ action: 'edit', id: grupo._id })}
                        >
                            <span className="sf-row-body">
                                <span className="sf-row-title">{grupo.name || 'Grupo sem nome'}</span>
                                {!!grupo.description && <span className="sf-row-sub">{grupo.description}</span>}
                            </span>
                            <ChevronRight className="sf-chevron" aria-hidden />
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
